import React, {useState, useRef} from 'react';

import 'index.css';
import './Tooltip.scss';

const Tooltip = ({visible, title, id, offset, children}) => {
  const [isOver, setIsOver] = useState(false);
  const tooltipContainerRef = useRef(null);
  const tooltipRef = useRef(null);

  const tooltipContainerWidth = tooltipContainerRef.current ? tooltipContainerRef.current.offsetWidth : 0;
  const tooltipWidth = tooltipRef.current ? tooltipRef.current.offsetWidth : 0;

  const min = tooltipWidth / 2;
  const max = tooltipContainerWidth - min;
  const leftOffset = offset * tooltipContainerWidth;

  let processedOffset = leftOffset;
  processedOffset = processedOffset < min ? min : processedOffset;
  processedOffset = processedOffset > max ? max : processedOffset;

  return (
    <div ref={tooltipContainerRef} className="tooltip-container">
      <div
        className={`tooltip ${isOver && visible ? 'show' : 'hide'}`}
        ref={tooltipRef}
        id={id}
        style={{left: processedOffset + 'px'}}
      >
        {title}
      </div>
      <div onMouseEnter={() => setIsOver(true)} onMouseLeave={() => setIsOver(false)}>
        {children}
      </div>
    </div>
  );
};

export default Tooltip;
